<template>
    <div class="ProjectSpecComponent">
        <p v-if="selectedRevisionRow.length == 0">{{ lang.infotext_1 }}</p>
        <span v-if="selectedRevisionRow.length > 0">
            <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText">
                <b-form-group label-cols-lg="3" :label="lang.titlepanel_GeneralInformation" label-size="sm"
                    label-class="font-weight-bold pt-0" class="mb-0">
                    <b-form-group :label="lang.label_CADProjectTitle+':'" label-for="first-a" label-cols-sm="3"
                        label-align-sm="right">
                        <b-form inline>
                            <b-form-input id="first-a" v-model="form.CADProjectTitle"></b-form-input>
                            <tooltip-icon icon="info" bold text="lang.button_Back" :tooltip="lang.info_CADProjectTitle"
                                :disabled="false" />
                        </b-form>
                    </b-form-group>

                    <b-form-group :label="lang.label_ERP_PMLProjectTitle + ':'" label-for="first-b" label-cols-sm="3"
                        label-align-sm="right">
                        <b-form inline>
                            <b-form-input id="first-b" v-model="form.ERP_PMLProjectTitle"></b-form-input>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_ERP_PMLProjectTitle"
                                :disabled="false" />
                        </b-form>
                    </b-form-group>

                    <b-form-group :label="lang.label_PCBAProductNumber + ':'" label-for="first-c" label-cols-sm="3"
                        label-align-sm="right">
                        <b-form inline>
                            <b-form-input id="first-c" v-model="form.PCBAProductNumber"></b-form-input>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_PCBAProductNumber"
                                :disabled="false" />
                        </b-form>
                    </b-form-group>


                </b-form-group>
            </b-card>


            <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText">
                <b-form-group label-cols-lg="3" :label="lang.titlepanel_CommercialParameters" label-size="sm"
                    label-class="font-weight-bold pt-0" class="mb-0">
                    <b-form-group :label="lang.label_ProductionQuantity + ':'" label-for="second-a" label-cols-sm="3"
                        label-align-sm="right">
                        <b-form inline>
                            <b-form-input id="second-a" v-model="form.ProductionQuantity"></b-form-input>
                            <tooltip-icon icon="info" bold text="lang.button_Back"
                                :tooltip="lang.info_ProductionQuantity" :disabled="false" />
                        </b-form>
                    </b-form-group>

                    <b-form-group :label="lang.label_MaxPCBAPrice + ':'" label-for="second-b" label-cols-sm="3"
                        label-align-sm="right">
                        <b-form inline>
                            <b-form-input id="second-b" v-model="form.MaxPCBAPrice"></b-form-input>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_MaxPCBAPrice"
                                :disabled="false" />
                        </b-form>
                    </b-form-group>

                    <b-form-group :label="lang.label_PriceForPCBboard + ':'" label-for="second-c" label-cols-sm="3"
                        label-align-sm="right">
                        <b-form inline>
                            <b-form-input id="second-c" v-model="form.PriceForPCBBoard"></b-form-input>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_PriceForPCBboard"
                                :disabled="false" />
                        </b-form>
                    </b-form-group>




                </b-form-group>

            </b-card>
            <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText">
                <b-form-group label-cols-lg="3" :label="lang.titlepanel_RequiredStandards" label-size="sm"
                    label-class="font-weight-bold pt-0" class="mb-0">

                    <b-form-group :label="lang.label_UL + ':'" label-cols-sm="3" label-align-sm="right" class="mb-0">
                        <b-form inline>
                            <b-form-radio-group class="pt-2"
                                :options="[lang.value_UL_1, lang.value_UL_2, lang.value_UL_3]"
                                v-model="form.UL"></b-form-radio-group>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_UL" :disabled="false" />
                        </b-form>
                    </b-form-group>
                    <b-form-group :label="lang.label_RoHS + ':'" label-cols-sm="3" label-align-sm="right" class="mb-0">
                        <b-form inline>
                            <b-form-radio-group class="pt-2"
                                :options="[lang.value_RoHS_1, lang.value_RoHS_2, lang.value_RoHS_3]"
                                v-model="form.RoHS"></b-form-radio-group>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_RoHS" :disabled="false" />
                        </b-form>
                    </b-form-group>
                    <b-form-group :label="lang.label_REACH + ':'" label-cols-sm="3" label-align-sm="right" class="mb-0">
                        <b-form inline>
                            <b-form-radio-group class="pt-2"
                                :options="[lang.value_REACH_1, lang.value_REACH_2, lang.value_REACH_3]"
                                v-model="form.REACH_EG_1907_2006"></b-form-radio-group>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_REACH" :disabled="false" />
                        </b-form>
                    </b-form-group>
                    <b-form-group :label="lang.label_WEEE + ':'" label-cols-sm="3" label-align-sm="right" class="mb-0">
                        <b-form inline>
                            <b-form-radio-group class="pt-2"
                                :options="[lang.value_WEEE_1, lang.value_WEEE_2, lang.value_WEEE_3]"
                                v-model="form.WEEE"></b-form-radio-group>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_WEEE" :disabled="false" />
                        </b-form>
                    </b-form-group>



                </b-form-group>

            </b-card>
            <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText">
                <b-form-group label-cols-lg="3" :label="lang.titlepanel_OperatingThermalRangeRequirements"
                    label-size="sm" label-class="font-weight-bold pt-0" class="mb-0">
                    <b-form-group label="" label-for="fourth-select" label-cols-sm="3" label-align-sm="right">
                        <b-form inline>
                            <b-form-select v-model="thermalRange" :options="options_Trange" size="sm"
                                class="mt-3"></b-form-select>
                        </b-form>
                    </b-form-group>



                    <b-form-group :label="lang.label_TAmin + ':'" label-for="fourth-a" label-cols-sm="3"
                        label-align-sm="right">
                        <b-form inline>
                            <b-form-input id="fourth-a" v-model="form.TAmin"></b-form-input>
                            <tooltip-icon icon="info" bold text="lang.button_Back" :tooltip="lang.info_TAmin"
                                :disabled="false" />
                        </b-form>
                    </b-form-group>

                    <b-form-group :label="lang.label_TAmax + ':'" label-for="fourth-b" label-cols-sm="3"
                        label-align-sm="right">
                        <b-form inline>
                            <b-form-input id="fourth-b" v-model="form.TAmax"></b-form-input>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_TAmax" :disabled="false" />
                        </b-form>
                    </b-form-group>

                    <b-form-group :label="lang.label_TA + ':'" label-for="fourth-c" label-cols-sm="3"
                        label-align-sm="right">
                        <b-form inline>
                            <b-form-input id="fourth-c" v-model="form.TA"></b-form-input>
                            <tooltip-icon icon="info" bold text="" :tooltip="lang.info_TA" :disabled="false" />
                        </b-form>
                    </b-form-group>




                </b-form-group>

            </b-card>
        </span>
    </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import TooltipIcon from '@/components/shared/TooltipIcon.vue'

export default {
    name: 'ProjectSpecComponent',
    props:{
        lang: Object
    },
    components: {
        TooltipIcon

    },
    data () {
        return {
            options_Trange: [
                { value: 0, text: "Custom" },
                { value: 1, text: "AEC-Q100 Level 2   −40°C to 105°C" },
                { value: 2, text: "Automotive 	    	−40°C to 125°C" },
                { value: 3, text: "Commercial 		    0°C to   70°C" },
                { value: 4, text: "Consumer Office	  10°C to   35°C" },
                { value: 5, text: "Industrial 		−20°C to   85°C" },
                { value: 6, text: "Industrial Extended 	−40°C to   85°C" },
                { value: 7, text: "Military 		−55°C to 125°C" },
                                

            ],
            thermalRange: 0,
            form: {
                projectRevisionId: 0,
                CADProjectTitle: "1",
                ERP_PMLProjectTitle: "",
                PCBAProductNumber: "",
                ProductionQuantity: "",
                MaxPCBAPrice: "",
                PriceForPCBBoard: "",
                UL: "",
                RoHS: "",
                REACH_EG_1907_2006: "",
                WEEE: "",
                ThermalRange: 0,
                TAmin: "",
                TAmax: "",
                TA: ""
            },
            form_reset: {
                projectRevisionId: 0,
                CADProjectTitle: "",
                ERP_PMLProjectTitle: "",
                PCBAProductNumber: "",
                ProductionQuantity: "",
                MaxPCBAPrice: "",
                PriceForPCBBoard: "",
                UL: "",
                RoHS: "",
                REACH_EG_1907_2006: "",
                WEEE: "",
                ThermalRange: 0,
                TAmin: "",
                TAmax: "",
                TA: ""
            }
        }
    },
    computed: {
        revisionId() {

            if (this.$store.getters.selectedRevisionRow[0] == undefined) {

                return this.$route.query.revisionId;
            }
            return this.$store.getters.selectedRevisionRow[0].revisionId;
        },
        selectedRevisionRow() {
            return this.$store.getters.selectedRevisionRow;
        },
        colors() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return ['tabs-bg-dark', 'tabs-text-light']
            } else {
                return ['tabs-bg-light', 'tabs-text-dark']
            }

        },
        textColors() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return ['tabs-bg-dark', 'tabs-text-light']
            } else {
                return ['tabs-bg-light', 'tabs-text-dark']
            }

        },
        cardColorsBg() {
            return "transparent"
            if (this.$store.getters.s_skinVariant == "dark") {
                return "dark";
            } else {
                return "secondary";
            }

        },
        cardColorsText() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "white";
            } else {
                return "dark"
            }

        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },

    },
    created() {

        this.getParams();


    },
    watch: {
        revisionId: function (newVal, oldVal) {

            
            this.getParams();

        }, 
        thermalRange: function (newVal) {
            
            
            if (newVal == 0) {
                this.form.TAmin = "";
                this.form.TAmax = "";
            }
            if (newVal == 1) {
                this.form.TAmin = "−40°C";
                this.form.TAmax = "105°C";
            }
            if (newVal == 2) {
                this.form.TAmin = "−40°C";
                this.form.TAmax = "125°C";
            }
            if (newVal == 3) {
                this.form.TAmin = "0°C";
                this.form.TAmax = "70°C";
            }
            if (newVal == 4) {
                this.form.TAmin = "10°C";
                this.form.TAmax = "35°C";
            }
            if (newVal == 5) {
                this.form.TAmin = "−20°C";
                this.form.TAmax = "85°C";
            }
            if (newVal == 6) {
                this.form.TAmin = "−40°C";
                this.form.TAmax = "85°C";
            }
            if (newVal == 7) {
                this.form.TAmin = "−55°C";
                this.form.TAmax = "125°C";
            }

            this.form.thermalRange = newVal;

        }
    },
    updated() {
        
        this.setParams();

    },
    
    methods: {
        getParams() {
            let vue = this;

            let obj = {
                projectRevisionId: this.revisionId
            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProjectSpec", obj)
                .then((result) => {
                    console.log(result.data)

                    if (result.status == "OK") {

                        if (result.data.length == 1) {
                            vue.form = result.data[0];
                            vue.thermalRange = result.data[0].ThermalRange;
                        } else {
                            vue.form = vue.form_reset;
                            vue.thermalRange = 0;
                        }
                        
                    }

                })
        },
        setParams() {

            this.form.projectRevisionId = this.revisionId;
            this.$store.commit("SETPROJECTSPEC", this.form);
            
        }


    }
}
</script>


<style lang="scss">
@import "@/scss/_custom.scss";

    .ProjectSpecComponent{
        .card-text {
                margin: 10px;
            }
        
            .panels {
                margin: 10px;
            }
        
            .button-save {
                margin: 10px;
            }
        
            .card-title {
                margin-left: 10px;
            }
        
            .card {
                margin-top: 5px;
            }
            
    }


</style>


// WEBPACK FOOTER //
// src/components/shared/ProjectSpecComponent.vue